var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 1.33333V4M4.33333 1.33333V4M1 6.66667H13M2.33333 2.66667H11.6667C12.403 2.66667 13 3.26362 13 4V13.3333C13 14.0697 12.403 14.6667 11.6667 14.6667H2.33333C1.59695 14.6667 1 14.0697 1 13.3333V4C1 3.26362 1.59695 2.66667 2.33333 2.66667Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCalendar;